import { InSeasonSpecies } from '@domain/regulations/getInSeasonSpecies';
import { getSpeciesUrl } from '@domain/routes/urls';

export const formatLinkedSpeciesString = (species: InSeasonSpecies[]): string => {
  const anchors = species.map(
    s => `<a href="${getSpeciesUrl(s._id, s.displayName)}">${s.displayName}</a>`,
  );
  if (anchors.length <= 1) {
    return anchors.join('');
  }
  return `${anchors.slice(0, -1).join(', ')}, and ${anchors[anchors.length - 1]}`;
};
